import { Link } from 'react-router-dom';

export default function ForgotPasswordPage(): JSX.Element {
  return (
    <div className="grid min-h-screen place-items-center bg-pearl px-6 py-12">
      <div className="w-full max-w-md rounded-card border border-line bg-white p-8 shadow-soft">
        <h1 className="font-display text-xl font-extrabold text-navy-700">
          Mot de passe oublié
        </h1>
        <p className="mt-3 font-sans text-sm text-sub">
          La récupération de mot de passe en libre-service sera disponible en Phase 2. Pour le
          moment, contactez votre administrateur Harmaury pour réinitialiser votre accès.
        </p>
        <Link
          to="/login"
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-navy-700 px-5 py-2.5 font-display text-sm font-bold text-white hover:bg-navy-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2"
        >
          Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
